import React from 'react'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Footer from './Footer'



function Extendedstay() {
    return (
        <div className="stay_container">
            <div className="header_sections">
                <div className="header_links">
                <p>All hotel deals </p>
                    <KeyboardArrowRightIcon />
                    <p>
                    <a href="https://www.softwaredevbytes.com">Extended stay rates</a>
                    </p>
                </div>
               
                     <div className="header_inputs">
                         <input className="header_inputsfirst" type="text" />
                         <input  className="header_inputssecond" type="button" value="Search" />
                     </div>

            </div>
            <div className="deals_img">
                <img src="assets/hotel room2.webp" alt="hotel" />
            </div>
            <div className="overlay_home"></div>
            <div className="staycontainer_contents">
                <div className="staycontents_box">
                    <h2>
                    Extended stay rates
                    </h2>
                </div>
                <div className="staycontents_form">
                    <form action="">
                        <div className="stayform_input">
                            <input className="stay_input" type="search" name="" id="" placeholder="Enter a city" />
                            <input className="stay_input" type="number" name="" id="" placeholder='1' />
                            <input className="stay_date" type="date" name="" id="" />
                            <input className="stay_date" type="date" name="" id="" />
                            <input className="stay_button" type="button" value="Continue" />
                        </div>
                    </form>
                </div>
            </div>

            <div className="staycontainer_others">
                <div className="staycontainer_otherscontent">
                    <h2>
                    Extended stay hotels / long term hotel stays
                    </h2>
                    <h4>
                    Reserving extended stay travel for teams and other
                     long-term stays
                    </h4>
                    <p>
                    Organising extended stay travel can seem like a daunting task, 
                    but it is important to pick the right hotel, because a small
                     mistake
                     is increased with the inconvenience it causes over time.
                      Having years
                      of experience and the largest database of the best
                       extended stay hotels
                       worldwide, our technology will enable you find the
                        perfect extended
                        stay hotel.
                    </p>

                </div>
            </div>
            <div className="staycontainer_more">
                <div className="morestay_container">
                    <h2>
                    Hotel arrangements for your extended stay travel
                    </h2>
                    <p>
                    Advance preparation is key in order to pick the 
                    perfect hotel accommodation for your extended stay. 
                    Our technology is perfect for this as it allows you to
                     search multiple extended stay hotel accommodation at 
                     the same time. It's important that you find the right
                      hotel accommodation, because you will be spending a 
                      lot of time there. This is why CharlieFerence is the
                       perfect tool to help you research and reserve a block
                        of rooms for your extended stay, with the best rates
                         guaranteed.

                    </p>
                    <p>
                    To accomplish this goal easily you can fill out our quick
                     online RFP page and a CharlieFerence Account Representative 
                     will be assigned to you. They will help you navigate your 
                     customised online extended stay booking engine. This system
                      will supply you with organised detailed descriptions of all
                       travel amenities and local attractions before you make any 
                       decisions. A great source we have found for easily comparing
                        different hotel internet rates is CharlieFerence.com
                         (www.CharlieFerence.com). This site allows you to use the 
                         power of the internet to get the best prices for your 
                         hotel reservations every time, guaranteed. The best thing
                          about the system is that it is the best technology in the
                           industry and it is very easy to use. All you need to do
                           
                            is put in your extended stay group travel hotel
                             accommodation options and dates and HotelPlanner.com
                              will do the rest. It will allow you to search hotel 
                              group rates in multiple cities at the same time, in a 
                              clear and organised approach without Hotel bias. 
                              It also puts you in control of sorting through this 
                              information by hotel accommodation, price or hotel
                               brand.CharlieFerence will also assign an account
                                representative to you that will help make sure your
                                 hotel deals are not only the best, but the hotel
                                  accommodation will also fit your extended stay
                                   needs. They will also help with the reservation 
                                   process. The reservation process is very important
                                    because even if the room rate is very low, the deal 
                                    may include a very strict cancellation policy, a large
                                     deposit or other hidden costs such as mandatory fees.
                                      Your CharlieFerence.com Account Representative will be 
                                      more than happy to help through these and any other issues
                                       you may encounter. After choosing your hotel they will set up
                                        an executive online booking website just for your extended 
                                        stay group travel free of charge. This will help you keep 
                                        track of your extended stay group travel members as they 
                                        confirm their travel arrangements.
                    </p>

                </div>
            </div>



            <Footer />



            
        </div>
    )
}

export default Extendedstay
